import { Box, Button } from '@eatclubcode/ec-component-library';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import useStyles from './CancelMembershipStyles';
import RightArrowSVG from '../../assets/icon_small_arrow_right.svg';

const ContinueButton = ({ onClick, children, ...others }) => {
  const classes = useStyles();

  return (
    <Button
      type='text'
      style={{ button: { textDecoration: 'underline' } }}
      onClick={onClick}
      {...others}
    >
      <Box className={classes.continueButton}>
        <Box className={classes.continueButtonText}>{children}</Box>
        <Box className={classes.continueArrow}>
          <RightArrowSVG />
        </Box>
      </Box>
    </Button>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContinueButton);
